module.exports = __webpack_public_path__ + "static/media/thumbnail.34f6212c.jpg";